import React from 'react'

export default function Toggle({ value, onChange, options }) {
  return (
    <div className="flex gap-2 bg-white/10 p-1 rounded-lg" role="radiogroup" aria-label="Dining option">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          onClick={() => onChange(option.value)}
          className={`flex-1 py-2 rounded-md font-medium transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 ${
            value === option.value
              ? 'bg-white text-sky-900 shadow'
              : 'text-white'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
